import Presentation from "./presentation";

const CreatorCards = ( {
	data,
	fetchMore,
	isDepleted,
	isLoading
} ) => {
	return (
		<Presentation
			data       = { data }
			fetchMore  = { fetchMore }
			isDepleted = { isDepleted }
			isLoading  = { isLoading }
		/>
	);
};

export default CreatorCards;